import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import Swal from 'sweetalert2';
import _ from "lodash";
import axios from 'axios';
import Select from 'react-select';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify'
import { Link, useNavigate } from 'react-router-dom';

import {
  getCategary,
  getSubCategory,
  getPayment
} from "requests/user";
import api from "utils/api";
const MoneyTranfer = () => {
  const config = useSelector((state) => state.config);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [mobileNumber, setMobileNumber] = useState('');
  const [amount, setAmount] = useState('');
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const titles = [{ title: "Merchant" }];
   const [isLoading, setIsLoading] = useState(false);
  const [baseUrl, setBaseUrl] = useState('');
  const token = Cookies.get('sob_token');
  const navigate = useNavigate();

useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await getCategary();
      setCategories(res.data.data);
    } catch (err) {
      console.error('Error fetching categories:', err);
    }
  };
  fetchCategories();
}, []);


const getSubCategories = async (categoryId) => {
  try {
    const res = await getSubCategory(categoryId);
    if (res.data.status === '1') {
      setSubCategories(res.data.data);
      setBaseUrl(res.data.baseUrl);
    } else {
      setSubCategories([]);
    }
  } catch (err) {
    console.error('Error fetching subcategories:', err);
  }
};

  const handleMobileNumberChange = (e) => {
    let number = e.target.value.replace(/\D/g, '');
    if (number.length > 10) number = number.slice(0, 10);
    setMobileNumber(number);
  };

const handlePayment = async (e) => {
  e.preventDefault();

  if (!selectedCategory) {
    return Swal.fire('Error', 'Please select a category.', 'error');
  }

  if (!selectedOperator) {
    return Swal.fire('Error', 'Please select an operator.', 'error');
  }

  if (!mobileNumber || mobileNumber.length !== 10) {
    return Swal.fire('Error', 'Please enter a valid 10-digit mobile number.', 'error');
  }

  if (!amount || parseFloat(amount) <= 0) {
    return Swal.fire('Error', 'Please enter a valid amount.', 'error');
  }

  const payload = {
    mobile_number: mobileNumber,
    amount,
    bill_category_id: selectedCategory.value,
    operator_name: selectedOperator.label,
    operator_id: selectedOperator.value,
    paymentMode: 'Cash',
  };

  try {
    setIsLoading(true);
    const res = await getPayment(payload);

    if (res.data.status === '1') {
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Payment processed successfully!',
        timer: 2000,
        showConfirmButton: true,
      }).then(() => {
        localStorage.setItem('txnRefId', res.data.data.txnRefId);
        localStorage.setItem('mobileNumber', res.data.data.user_mobile);
        navigate(`/billpayreceipt/${res.data.data._id}`);
      });
    } else {
      Swal.fire('Error', res.data.message || 'Payment failed', 'error');
    }
  } catch (error) {
    console.error('Payment error:', error);
    Swal.fire('Error', 'An error occurred while processing the payment.', 'error');
  }
  finally {
    setIsLoading(false);
  }
};

  const categoryOptions = categories?.map((cat) => ({
    value: cat._id,
    label: cat.name,
  }));

  const operatorOptions = Array.isArray(subCategories)  ? subCategories.map((sub) => ({
    value: sub._id,
    label: sub.name,
    image: sub.image,
  })) : [];

   useEffect(() => {
      if (categories) {
        const moneyTransfer = categories.find(cat => cat.name === "Money Transfer");
        if (moneyTransfer) {
          const selected = {
            value: moneyTransfer._id,
            label: moneyTransfer.name,
          };
          setSelectedCategory(selected);
          getSubCategories(moneyTransfer._id); 
        }
      }
    }, [categories]);

  const customSingleValue = ({ data }) => (
    <div style={{ display: 'flex', alignItems: 'center' }} className='custom-single-value'>
      {data.image && (
        <img
          src={`${baseUrl}/${data.image}`}
          alt={data.label}
          style={{ width: 24, height: 24, marginRight: 8, borderRadius: 4 }}
        />
      )}
      {data.label}
    </div>
  );

  const customOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center', padding: 8 }}>
        {data.image && (
          <img
            src={`${baseUrl}/${data.image}`}
            alt={data.label}
            style={{ width: 24, height: 24, marginRight: 8, borderRadius: 4 }}
          />
        )}
        {data.label}
      </div>
    );
  };

  return (
    <section className='home' id='home'>
      <div className='container'>
        <div className='col-md-6 order-md-2 order-1'>
          <div className='billprocesspayment'>
            <div className='headerbillname'>
              <h3>Bharat Connect Billers</h3>
            </div>

            {/* Category Select */}
            <div className='select-container'>
              <label className='labeldesign'>Bill Category</label>
              {/* <Select
                options={categoryOptions}
                className='billcategorydesign'
                placeholder='Select a category'
                onChange={(selected) => {
                  setSelectedCategory(selected);
                  getSubCategories(selected.value);
                  setSelectedOperator(null);
                  setMobileNumber('');
                  setAmount('');
                }}
              /> */}
                <Select
                options={categoryOptions}
                className='billcategorydesign'
                placeholder='Select a category'
                value={selectedCategory}
                isDisabled 
              />               
            </div>

            {/* Operator Select */}
            {subCategories && subCategories.length > 0 && (
              <div className='select-container'>
                <label className='labeldesign'>Operator</label>
                <Select
                  className='billcategorydesign'
                  placeholder='Select Operator'
                  options={operatorOptions}
                  onChange={(selected) => setSelectedOperator(selected)}
                  components={{ SingleValue: customSingleValue, Option: customOption }}
                />                         
              </div>
            )}

            {/* Mobile Number Input */}
            {selectedOperator && (
              <div className='select-container'>
                <label className='labeldesign'>Mobile Number</label>
                <input
                  type='text'
                  className='form-custum form-control'
                  placeholder='Enter Mobile Number'
                  value={mobileNumber}
                  onChange={handleMobileNumberChange}
                  maxLength='10'
                />
              </div>
            )}

            {/* Amount Input */}
            {mobileNumber.length === 10 && (
              <div className='select-container'>
                <label className='labeldesign'>Amount</label>
                <input
                  type='number'
                  className='form-custum form-control'
                  placeholder='Enter Amount'
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
              </div>
            )}

            {/* Submit Button */}
            {/* <div className='select-container'>
              <button
                onClick={handlePayment}
                className='btn w-100 paybillbutton login-form--button'
              >
                Proceed To Recharge
              </button>
            </div> */}
             <div className='select-container'>
              <button
                onClick={handlePayment}
                className='btn w-100 paybillbutton login-form--button'
                disabled={isLoading}
              >
               {isLoading?(
                <span>
              <i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
               Processing...
                </span>
               ):(
                 'Proceed To Recharge'

               )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MoneyTranfer;
